import type { PregnancyState } from "./PregnancyContext";

export type PregnancyFlowRoute =
  | "PregnancyUsage"
  | "PregnancyDetails"
  | "PregnancyComplete";

export function buildPregnancyNavigationStack(
  state: PregnancyState,
): PregnancyFlowRoute[] {
  const stack: PregnancyFlowRoute[] = ["PregnancyUsage"];

  if (state.hasBeenPregnant === true) {
    stack.push("PregnancyDetails");
  }

  stack.push("PregnancyComplete");
  return stack;
}
